export default __webpack_public_path__ + "img/mastertitle-5071ecd7.png";